import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import {
  REORDER_SLIDES,
  REORDER_SLIDES_FAIL,
  REORDER_SLIDES_SUCCESS,
  ReorderSlidesAction
} from '../redux/manageSlidesReducer'
import { Slide } from '../types'

function* ReorderSlidesFlow(action: ReorderSlidesAction): Generator<any, void, any> {
  try {
    const response: Slide[] = yield call(apiCall, {
      endpoint: `/tutors/lesson_plans/${action.payload.lessonPlanId}/slides/reorder`,
      method: 'POST',
      params: {
        reorder_params: action.payload.ids
      }
    })

    yield put(REORDER_SLIDES_SUCCESS({ lessonPlanId: action.payload.lessonPlanId, slides: response }))
  } catch (error) {
    yield put(REORDER_SLIDES_FAIL())
    console.log(error)
  }
}

export default function* ReorderSlidesSaga(): Generator<any, void, any> {
  yield takeLatest([REORDER_SLIDES], ReorderSlidesFlow)
}
